import React, {useEffect} from "react";
import {connect} from "react-redux";
import WizardPopupSceneSelectionItem from "./WizardPopupSceneSelectionItem";
import {setWizardPopupDisabledScenes} from "../../wizardActions";
import {getDefaultPresets} from "../../../VisualizerManagement/VisualizerManagementActions";


const WizardPopupSceneSelection = (props) => {

  const {wizardPopupItem, defaultBvPresets, defaultKvPresets, wizardVisualizer, setWizardPopupDisabledScenes, loading,
    getDefaultPresets, presetsReceived} = props;

  useEffect(() => {
    if (!presetsReceived) {
      getDefaultPresets();
    }
    setWizardPopupDisabledScenes(wizardPopupItem.disabledScenes);
  }, [])

  if (loading) {
    return (
      <div className="wizard-popup-content">
        <div className="ui-loader"/>
      </div>
    )
  }

  const list = wizardVisualizer === "bathroom" ? defaultBvPresets : defaultKvPresets;

  return (
    <div className="wizard-presets">
      <ul className="wizard-presets__list fix-ul">
        {list.map((preset, presetIndex) => {
          return <WizardPopupSceneSelectionItem key={preset.id || "list" + presetIndex} preset={preset} />
        })}
      </ul>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardPopupItem, wizardVisualizer} = store.wizardState;
  const {defaultBvPresets, defaultKvPresets, loading, presetsReceived} = store.visualizerManagement;

  return {
    loading,
    presetsReceived,
    wizardVisualizer,
    wizardPopupItem,
    defaultBvPresets,
    defaultKvPresets
  };
};

const mapDispatchToProps = {
  setWizardPopupDisabledScenes,
  getDefaultPresets,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(WizardPopupSceneSelection)
)
